import { render, staticRenderFns } from "./RestaurantContactLocation.vue?vue&type=template&id=cc0584aa&scoped=true&"
import script from "./RestaurantContactLocation.vue?vue&type=script&lang=js&"
export * from "./RestaurantContactLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0584aa",
  null
  
)

export default component.exports